<div class="card border-0 p-0">
  <div class="card-body p-0">
    <!-- Title -->
    <div *ngIf="title" class="fw-bold mb-3">{{ title }}</div>

    <!-- Run Sync -->
    <div class="d-flex align-items-center mb-3">
      <div class="fw-bold me-3" style="width: 180px;">Run Sync</div>
      <button (click)="onSync()" class="btn btn-sm btn-outline-success">
        <i class="bi bi-arrow-repeat"></i> Sync Now
      </button>
    </div>

    <!-- Schedule Editor -->
    <div class="fw-bold mb-2">Update Schedule <span class="text-muted small">(Times in CST)</span></div>
    <div class="card shadow-sm mb-2">
      <div class="card-body">
        <cron-editor #cronEditorDemo
                     [(cron)]="cronExpression"
                     [disabled]="isCronDisabled"
                     [options]="cronOptions">
        </cron-editor>
      </div>
    </div>

    <div class="small text-muted mb-3">Expression: {{ cronExpression }}</div>

    <!-- Action Buttons -->
    <div class="d-flex gap-2">
      <button (click)="onSubmit()" class="btn btn-sm btn-primary">
        <i class="bi bi-save"></i> Save
      </button>
      <button (click)="onDelete()" class="btn btn-sm btn-danger">
        <i class="bi bi-trash"></i> Delete
      </button>
    </div>
  </div>
</div>
